import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import CloudUpload from '@mui/icons-material/CloudUpload';
import theme from '../../../theme/theme';
const pulseAnimation = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(74, 111, 232, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(74, 111, 232, 0); }
  100% { box-shadow: 0 0 0 0 rgba(74, 111, 232, 0); }
`;
const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;
export const Root = styled(Box)({
  padding: '32px',
  borderRadius: '16px',
  background: 'transparent',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
});
export const Row = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  width: '100%',
  position: 'relative',
});
export const ContentContainer = styled(Box)({
  flex: 1,
});
export const IconWrap = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  background: 'rgba(74, 111, 232, 0.1)',
  animation: `${pulseAnimation} 2s infinite`,
});
export const Title = styled(Typography)({
  color: theme.palette.text.primary,
  fontSize: '16px',
  fontWeight: 600,
  marginBottom: '8px',
  transition: 'all 0.3s ease',
});
export const ProgressWrap = styled(Box)({
  position: 'relative',
});
export const StyledLinearProgress = styled(LinearProgress)({
  height: '10px !important',
  borderRadius: '5px',
  background: 'rgba(226, 232, 240, 0.5)',
  '& .MuiLinearProgress-bar': {
    borderRadius: '5px',
    background: theme.palette.primary.main,
    transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  },
});
export const BottomRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '32px',
  height: '32px',
});
export const AnimatedText = styled(Typography)({
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  marginTop: '4px',
  textAlign: 'center',
  letterSpacing: '0.2px',
  display: 'flex',
  alignItems: 'center',
  minHeight: '24px',
  position: 'relative',
  borderRadius: '8px',
  padding: '4px 12px',
});
export const StyledCloudUploadIcon = styled(CloudUpload)({
  color: theme.palette.primary.main,
  fontSize: 32,
  animation: `${floatAnimation} 3s ease-in-out infinite`,
});
